import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import {
  isEmptyCollection,
  isUrlNamesMatch,
  useApplicationState,
  useCasinoNewState,
  useLabel,
} from '@atlas/core';
import { ChipsItem, Icon, Label, SportsbookFilter } from '@atlas/ui';

import { useCasinoFilterState } from 'components/Casino/CasinoFilterContext';
import {
  casinoFilterTypeMap,
  deleteCasinoFilter,
  updateCasinoFilter,
} from 'components/Casino/useCasinoFilter';

import CategoryFilterItem from './CategoryFilterItem';

const CategoryFilter = ({ setIsSearchActive, setShowFavorites, showFavorites }) => {
  const { authenticated } = useApplicationState();
  const [title, setTitle] = React.useState(useLabel('all'));

  const {
    categories: { data: categories },
  } = useCasinoNewState();
  const { filter, updateFilter } = useCasinoFilterState();

  const selectedFilter = useMemo(() => {
    if (filter?.categories?.length && categories?.length) {
      const obj = categories?.find(
        category => Number(category.id) === Number(filter?.categories[0]),
      );
      setTitle(obj?.name);
      return [obj?.name];
    }
    return [];
  }, [categories, filter?.categories]);

  const onChangeCategory = useCallback(id => {
    setShowFavorites(false);
    updateFilter({ categories: [id.toString()] });

    updateCasinoFilter(casinoFilterTypeMap.category, id);
  }, []);

  const showAllCategories = useCallback(() => {
    setShowFavorites(false);

    deleteCasinoFilter(casinoFilterTypeMap.category);
  }, []);

  const showFavourites = useCallback(() => {
    setShowFavorites(!showFavorites);

    deleteCasinoFilter(casinoFilterTypeMap.category);
  }, [showFavorites]);

  const sortedCategories = useMemo(
    () => categories.sort((a, b) => a.position - b.position),
    [categories],
  );

  const openSearchHandler = useCallback(() => {
    setIsSearchActive(true);
  }, [setIsSearchActive]);

  return (
    <div className="casino-category-filter">
      <h1 className="d-none">{title}</h1>
      <button
        aria-label="casino-search"
        className="chips-item search"
        onClick={openSearchHandler}
        type="button"
      >
        <Icon name="search" />
      </button>
      <div className="chips-list">
        {authenticated && <ChipsItem active={showFavorites} icon="star" onClick={showFavourites} />}

        <SportsbookFilter
          ItemComponent={CategoryFilterItem}
          className="casino-filter"
          isUrlNamesMatch={isUrlNamesMatch}
          onChange={onChangeCategory}
          options={sortedCategories}
          selectedChips={selectedFilter}
          valueProperty="name"
        />

        <ChipsItem
          active={!showFavorites && isEmptyCollection(filter.categories)}
          label={<Label message="all" />}
          onClick={showAllCategories}
        />
      </div>
    </div>
  );
};

CategoryFilter.propTypes = {
  setIsSearchActive: PropTypes.func,
  setShowFavorites: PropTypes.func,
  showFavorites: PropTypes.func,
};

export default CategoryFilter;
